import React from 'react';
import ProductOverview from '../../product-overview/ProductOverview';
import product from '../all-gear.json';

const MenNikeDFLongSleeve = () => {
	return (
		<React.Fragment>
			<ProductOverview
				name={product.allGear[2].productName}
				color={product.allGear[2].color}
				size={product.allGear[2].sizes}
				price={product.allGear[2].price}
				img={product.allGear[2].img}
				miniImg1={product.allGear[2].miniImg1}
				miniImg2={product.allGear[2].miniImg2}
				miniImg3={product.allGear[2].miniImg3}
			/>
		</React.Fragment>
	);
};

export default MenNikeDFLongSleeve;
